<template>
    <div class="info-modal hide">

        <div class="info-modal-content study-2">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>

            <center>
                <span class="study-tab">Pivotal Study 2 Design<sup>1,2</sup></span>
            </center>

            <div class="study-content">
                <p>3-week, double-blind, placebo-controlled study in which patients were randomized into 2 groups:
                    JORNAY PM
                    or placebo</p>

                <p>JORNAY PM group initially dosed at 40 mg per day for 1 week, with scheduled titration as tolerated to
                    60
                    mg at week 2 and 80 mg at week 3</p>

                <p>N=161 (JORNAY PM: n=81; placebo: n=80)</p>



                <p style="font-size: 16px;">
                    <b>Primary endpoint:</b> ADHD-RS-IV <br />
                    <b>Secondary endpoints:</b> BSFQ, PREMB-R PM
                </p>


            </div>

            <center>
                <p class="refs" style="max-width:650px; margin: 10px auto;">ADHD-RS-IV, Attention-Deficit/Hyperactivity
                    Disorder-Rating Scale-IV; BSFQ, Before School Functioning Questionnaire; PREMB-R PM, Parent
                    Rating of Evening and Morning Behavior-Revised, Evening.
                </p>
            </center>

            <div class="study-refs">
                <p><b>References: 1.</b> JORNAY PM<sup>®</sup> [package insert]. Ironshore Pharmaceuticals &
                    Development,
                    Inc. <b>2.</b> Pliszka SR, Wilens TE, Bostrom S, et al. Efficacy and safety of HLD200,
                    delayed-release and extended-release methylphenidate, in children with
                    attention-deficit/hyperactivity
                    disorder. <i>J Child Adolesc Psychopharmacol.</i> 2017;27(6):474-482.
                </p>
            </div>

        </div>

    </div>
</template>

<script>
export default {


    props: {
        showModal: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        if (this.showModal == true) {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        }
    },
    watch: {
        showModal(newValue, oldValue) {
            console.log(newValue);
            if (newValue === true) {
                this.modalActive();
            }
        }
    },

    methods: {
        modalActive: function () {
            document.body.classList.add("overflow")
            this.$el.classList.remove('hide')
        },

        closeModal() {
            document.body.classList.remove("overflow")
            this.$el.classList.add('hide')
            this.$emit('closeModal')
        },
    }

}
</script>

<style lang="scss" scoped>
.study-content * {
    font-weight: 600;
}

.study-content strong,
.study-content b {
    font-weight: 800;
}

.study-content p {
    line-height: 1.3;
    margin: 25px 0 !important;
}

.study-content {
    padding: 25px 30px !important;
}
</style>